<template>
  <el-select clearable @change="handleChange" :value="data" placeholder="请选择">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in list" :key="index"></el-option>
  </el-select>
</template>

<script>
  export default {
    name: "CategoryProductType",
    props: ["value"],
    watch: {
      value: {
        immediate: true,
        handler: function(value) {
          this.data = value;
        }

      },

    },
    data() {
      return {
        // A  镍氢电池
        // B  磷酸铁锂电池
        // C  锰酸锂电池
        // D  钴酸锂电池
        // E  三元材料电池
        // F  超级电容器
        // G  钛酸锂电池
        // Z  其他
        data: "",
        list: [
            {
              name: "镍氢电池",
              value: "A"
            },
            {
              name: "磷酸铁锂电池",
              value: "B"
            },
            {
              name: "锰酸锂电池",
              value: "C"
            },
            {
              name: "钴酸锂电池",
              value: "D"
            },
            {
              name: "三元材料电池",
              value: "E"
            },
            {
              name: "超级电容器",
              value: "F"
            },
            {
              name: "钛酸锂电池",
              value: "G"
            },
            {
              name: "其他",
              value: "H"
            }
          ]
        }
      },
      methods: {
        handleChange(value) {
          this.data = value;
          this.$emit("input", value)
        }
      }
    }
</script>

<style scoped>

</style>
